import PropTypes from 'prop-types';
import React from 'react';

import { Sub } from 'components/Sub';
import Theme from 'styles/theme';

const Level3OptionText = ({ title, href, onClick }) => (
  <a className="Level3OptionText" href={href} onClick={onClick}>
    <Sub className="Level3OptionText__title">{title}</Sub>
    <style jsx global>
      {`
        .Level3OptionText {
          display: flex;
          align-items: center;
          width: 100%;
          padding: ${Theme.get('spacing-px')} 0;
          text-decoration: none;
        }

        .Level3OptionText:hover .Level3OptionText__title {
          text-decoration: underline;
        }
      `}
    </style>
  </a>
);

Level3OptionText.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Level3OptionText;
